
export default {
  name: 'ExportButton',
  props: {
    // [{ label: '用户', templates: [{ value:'customers', label:'客户', desc:'...' }] }]
    groups: { type: Array, required: true }
  },
  data () {
    return {
      show: false,
      selected: '',
      format: 'xlsx',
      downloading: false,
      formats: [
        { value: 'xlsx', label: 'Excel (.xlsx)' },
        { value: 'csv', label: 'CSV (.csv)' }
      ],
      // 订单范围筛选
      datePreset: '',
      dateFrom: '',
      dateTo: '',
      archived: '',
      filterStatuses: [],
      statusOptions: [
        { value: 'pending_confirm', label: '待确认' },
        { value: 'picked', label: '已配货' },
        { value: 'inspected', label: '已验货' },
        { value: 'delivering', label: '配送中' },
        { value: 'delivered', label: '已送达' },
        { value: 'confirmed', label: '已完成' },
        { value: 'cancelled', label: '已取消' }
      ]
    }
  },
  computed: {
    isOrderExport () {
      return this.selected && this.selected.startsWith('order-')
    }
  },
  methods: {
    async downloadTemplate () {
      if (!this.selected) return
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(`/export/template/${this.selected}`, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        })
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url; a.download = `Plato_${this.selected}_Import.xlsx`
        document.body.appendChild(a); a.click()
        document.body.removeChild(a); URL.revokeObjectURL(url)
      } catch (err) {
        alert('下载模板失败')
      }
    },
    open () {
      this.selected = ''
      this.format = 'xlsx'
      this.datePreset = ''
      this.dateFrom = ''
      this.dateTo = ''
      this.archived = ''
      this.filterStatuses = []
      this.show = true
    },
    async doExport () {
      if (!this.selected || this.downloading) return
      this.downloading = true
      try {
        const token = localStorage.getItem('token')
        const params = { format: this.format }
        // 订单范围筛选参数
        if (this.isOrderExport) {
          if (this.datePreset) params.datePreset = this.datePreset
          if (this.datePreset === 'custom') {
            if (this.dateFrom) params.dateFrom = this.dateFrom
            if (this.dateTo) params.dateTo = this.dateTo
          }
          if (this.archived) params.archived = this.archived
          if (this.filterStatuses.length) params.status = this.filterStatuses.join(',')
        }
        const res = await this.axios.get(`/export/${this.selected}`, {
          params,
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        })
        const disposition = res.headers['content-disposition'] || ''
        const match = disposition.match(/filename\*?=(?:UTF-8'')?([^;\s]+)/i) || disposition.match(/filename="?(.+?)"?$/i)
        let filename = match ? decodeURIComponent(match[1]) : `export.${this.format}`
        const blob = new Blob([res.data], { type: res.headers['content-type'] })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url; a.download = filename
        document.body.appendChild(a); a.click()
        document.body.removeChild(a); URL.revokeObjectURL(url)

        // 截断提示
        const truncated = res.headers['x-export-truncated']
        if (truncated === 'true') {
          const total = res.headers['x-export-totalcount'] || '?'
          const exported = res.headers['x-export-exportedcount'] || '?'
          alert(`数据量较大（共 ${total} 条），本次导出最近 ${exported} 条。\n请缩小时间范围后分批导出以获取完整数据。`)
        }

        this.show = false
      } catch (err) {
        console.error('导出失败:', err)
        alert('导出失败: ' + ((err.response && err.response.data && err.response.data.message) || err.message))
      } finally {
        this.downloading = false
      }
    }
  }
}
